export enum UnitOfMeasures {
  perSqFt = 1,
  perUnit = 2
}
